// SHARED
import Spinner from '@/views/elements/spinner.vue'
import TablePaginator from '@/views/elements/table-paginator.vue'
import noCardTablePaginator from '@/views/elements/no-card-table-paginator.vue'
import ApiImg from '@/views/elements/api-img.vue'
import imgPortal from '@/views/elements/img-portal.vue'
import autoForm from '@/views/elements/auto-form.vue'
import selectIdFromOrigin from '@/views/elements/select-id-from-origin.vue'
import mobiscrollInputSearch from '@/views/elements/mobiscroll-input-search.vue'
import usuarioCell from '@/views/elements/usuario-cell.vue'
import storageImgUploader from '@/views/elements/storage-img-uploader.vue'
import storageFileUploader from '@/views/elements/storage-file-uploader.vue'
import tinyCheck from '@/views/elements/tiny-check.vue'
import uiEditAutoModal from '@/views/elements/ui-edit-automodal.vue'
import gridInput from '@/views/elements/grid-input.vue'
import quicktableFilters from '@/views/elements/quicktable-filters.vue'
import DownloadAsCsvButton from '@/views/elements/DownloadAsCsvButton.vue'

function plugin (Vue) {
  // SHARED
  Vue.component('download-as-csv-button', DownloadAsCsvButton)
  Vue.component('quicktable-filters', quicktableFilters)
  Vue.component('ui-edit-auto-modal', uiEditAutoModal)
  Vue.component('gridInput', gridInput)
  Vue.component('apiImg', ApiImg)
  Vue.component('imgPortal', imgPortal)
  Vue.component('cPaginate', TablePaginator)
  Vue.component('tPaginate', noCardTablePaginator)
  Vue.component('autoForm', autoForm)
  Vue.component('selectIdFromOrigin', selectIdFromOrigin)
  Vue.component('mobiscrollInputSearch', mobiscrollInputSearch)
  Vue.component('usuarioCell', usuarioCell)
  Vue.component('storageImgUploader', storageImgUploader)
  Vue.component('storageFileUploader', storageFileUploader)
  Vue.component('tinyCheck', tinyCheck)
  Vue.component('spinner', Spinner)
  Vue.component('ui-spinner', Spinner)
  Vue.component('spinner', Spinner)
}

export default plugin
